import React from 'react'

import { graphql } from 'gatsby'
import htmr from 'htmr'
import styled from 'styled-components'

import Breadcrumbs from '../components/core/Breadcrumbs'
import Layout from '../components/core/layout'
import SEO from '../components/core/seo'
import NewsRoomHero from '../components/specific-to-template/newsroom/NewsroomHero'
import {
  above, colors, fontSize, space,
} from '../style/design-system'
import { formatPhoneNumber } from '../utils/phoneNumberFormatter'
import emails from '../utils/static-data/emails'
import { phoneNumbers } from '../utils/static-data/phoneNumbers'

const NewsroomSingle = ({ className, data, location }) => (
  <Layout>

    <SEO
      title={data.page.metaSeoTitle || data.page.title}
      description={data.page.metaSeoMetadesc || ''} />

    <div className={`${className} newsroom-single`}>
      <NewsRoomHero />
      <div className="container">
        <Breadcrumbs
          customCrumbs={[
            {
              pathname: '/',
              crumbLabel: 'Home',
            },
            {
              pathname: '/about/newsroom/',
              crumbLabel: 'Newsroom',
            },
            {
              pathname: location.pathname,
              crumbLabel: data.page.title,
            },
          ]} />
      </div>
      <div className="content">
        <div className="container">
          <div className="row">

            <div className="col-md-9">
              <div className="newsroom-content-column mb-10">
                { data.page.title && <h1 className="h2 blue mb-7">{htmr(data.page.title)}</h1> }
                {htmr(data.page.content)}
              </div>
            </div>

            <aside className="col-md-3">
              <div className="aside-section">
                <div className="baseline">
                  <h3 className="h3 mx-0">Media Inquiries</h3>
                </div>
                <ul>
                  <li><a href={`tel:${phoneNumbers.umaMedia}`}>{formatPhoneNumber(phoneNumbers.umaMedia)}</a></li>
                  <li><a href={`mailto:${emails.umaMedia}`}>{emails.umaMedia}</a></li>
                </ul>
              </div>
            </aside>

          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export const query = graphql`
  query($id: String!) {
    page: wpUmaarticle(
      id: {
        eq: $id
      }
    ) {
      content
      title
      metaSeoTitle
      metaSeoMetadesc
    }
  }
`

export default styled(NewsroomSingle)`
  background-color: ${colors.dev.gray.h()};
  
  h1 {
    margin-top: 0;
  }

  .newsroom-content-column {
    background-color: #fff;
    border-radius: ${space.a};
    box-shadow: 0 0 ${space.a} ${colors.dev.gray.b(0.25)}, ${space.a} ${space.a} ${space.b} ${colors.dev.gray.b(0.1)};
    padding: ${space.g};
  }

  aside {
    margin-bottom: ${space.g};

    ${above.md`
      margin-bottom: 0;
    `}

    .h3 {
      display: inline-block;
      margin-top: 0;
    }
    svg {
      color: ${colors.dev.orange.e()};
      font-size: ${fontSize.f};
      font-weight: bold;
      position: relative;
      top: ${space.a};
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }

  .baseline * {
    display: inline-block;
    vertical-align: baseline;
  }

  .alignright {
    float: right;
    margin-bottom: 1rem;
    margin-left: 1rem;
  }

  img.alignleft {
    float: left;
    margin-bottom: 1rem;
    margin-right: 1rem;
  }

  .wp-video {
    max-width: 100%;
    .wp-video-shortcode {
      max-width: 100%;
      height: auto;
    }
  }
`
